export default {
  batch: {
    status: "Status",
    totalDistance: "Total Distance (km)",
    productionEmission: "Production Emission (kg CO2e)",
    transportEmission: "Transport Emission (kg CO2e)",
    totalEmission: "Total Emission (kg CO2e)",
    tax: "Tax (€)",
    more: "More",
    fallbackDistanceWarning: "Distance calculated using fallback method, may have errors",
  },
  label: {
    start: "Start",
    end: "End",
    via: "Via",
    mode: "Transport Mode",
    weight: "Weight",
    cnCode: "CN Code",
  },
  placeholder: {
    start: "e.g. Shanghai, CN",
    end: "e.g. Rotterdam, NL",
    via: "e.g. Singapore, SG",
    mode: "Transport Mode",
    weight: "Enter weight",
    cnCode: "e.g. 25070080 or cement",
    location: "e.g. Shanghai, CN",
  },
  action: {
    addVia: "Add via point",
    remove: "Remove",
    calculate: "Calculate",
    loadMore: "Load more",
  },
  transport: {
    sea: "Sea",
    road: "Road",
    rail: "Rail",
    barge: "Barge",
  },
  unit: {
    tonne: "Tonne",
    kilogram: "Kilogram",
    pound: "Pound",
  },
  leg: {
    enable_detailed_mode: "Enable detailed mode to view emission factor values",
    detailed_mode: "Detailed mode",
    simple_mode: "Simple mode",
    origin: "Origin",
    destination: "Destination",
    transport_mode: "Transport Mode",
    distance: "Distance (km)",
    weight: "Weight (t)",
    cn_code: "CN Code",
    transport_emission: "Transport Emission (kg CO2e)",
    transport_emission_factor: "Transport Emission Factor",
    transport_emission_factor_id: "Transport Emission Factor ID",
    production_emission: "Production Emission (kg CO2e)",
    production_emission_factor: "Production Emission Factor",
    production_emission_factor_id: "Production Emission Factor ID",
    total_emission: "Total Emission (kg CO2e)",
  },
  error: {
    cnCodeSearchFailed: "CN Code Search Failed",
    cnCodeSearchFailedDesc: "Unable to query available CN codes, please check the network.",
    locationRequired: "Please enter a location",
    modeRequired: "Please select a transport mode",
    requiredFields: "Please fill all required fields",
    calculationFailed: "Calculation failed",
    checkInputs: "Please check inputs or try again later",
    cnCodeRequired: "Please enter CN code",
    weightRequired: "Please enter weight",
    maxViaPoints: "Maximum 3 via points allowed",
    cnCodeInvalid: "CN code can only contain letters, numbers and underscores, max 20 characters",
    weightPositive: "Weight must be positive",
    locationSearchFailed: "Location search failed",
    locationSearchFailedDesc: "Unable to connect to location service, please try again later.",
  },
  result: {
    title: "Calculation Result",
    selected: "Selected Option",
    alternative: "Recommended Option ({mode})",
    leg: "Leg {index}",
    totalDistance: "Total Distance",
    productionEmission: "Production Emission",
    transportEmission: "Transport Emission",
    totalEmission: "Total Emission",
    tax: "Carbon Tax",
  },
  page: {
    title: "CBAM Emission Calculator",
    single: "Single Calculation",
    batchTitle: "Batch Calculation",
    batch: {
      rowNumber: "Row",
      cnCode: "CN Code",
      weight: "Weight (t)",
      originCity: "Origin City",
      originCoords: "Origin Coords",
      destinationCity: "Destination City",
      destinationCoords: "Destination Coords",
      transportMode: "Transport Mode",
      error: "Error",
      errorRowsDetected:
        "Detected {count} error rows, automatically excluded. Only {validCount} valid rows saved.",
      errors: {
        invalidCsvHeader: "Invalid CSV header",
        headerMustBe: "Header must be exactly: {fields}",
        batchSizeExceed: "Batch size cannot exceed {maxSize}",
        csvValidationFailed: "CSV validation failed",
        checkFormat: "Check format or try again",
        invalidXlsxFile: "Invalid XLSX file",
        fileIsEmpty: "File is empty",
        invalidXlsxHeader: "Invalid XLSX header",
        xlsxValidationFailed: "XLSX validation failed",
      },
    },
    upgradeTip:
      "Upgrade to Pro to unlock segment weight and CN code calculation for improved CBAM compliance accuracy!",
    learnMore: "Learn more",
    reportTitle: "Emission Report",
    viewReport: "View Report",
    totalOverview: "Total Overview",
    origin: "Origin",
    destination: "Destination",
    totalDistance: "Total Distance",
    tax: "Tax",
    basedOnEUR: "Based on €{amount}",
    productionEmission: "Production Emission",
    transportEmission: "Transport Emission",
    totalEmission: "Total Emission",
    pleaseCalculateFirst: "Please calculate first",
    batchLimitInfo: "Free users support up to 10 records, paid users up to 200 records.",
    clearErrorData: "Clear Error Data",
    submitCalculation: "Submit Calculation",
    confirmDeleteTask: "Are you sure delete this task?",
    reupload: "Re-upload",
    uploadHint: "Click or drag file to this area to upload",
    csvOnlyHint: "Free version only supports csv, paid users support csv and xlsx",
    configFailed: "Failed to get configuration, please retry",
    batchResultSummary: "Total {total} records, {success} successful, {fail} failed",
    searchByCNCode: "Search by CN Code",
    downloadCSVTemplate: "Download CSV Template",
    downloadXLSXTemplate: "Download XLSX Template",
    previewReport: "Preview Report",
    to: "to",
    template: {
      saveTemplate: "Save Template",
      templateName: "Template Name",
      namePlaceholder: "Please enter template name",
      nameRequired: "Please enter template name",
      nameTooLong: "Template name cannot exceed 50 characters",
      formIncomplete: "Please complete the form before saving template",
      saveSuccess: "Template saved successfully",
      saveFailed: "Failed to save template",
    },
  },
  tooltip: {
    cnCode: "CN code consists of letters, numbers, and underscores, up to 20 characters",
  },
  progress: {
    title: "Batch Calculation",
    stages: {
      connecting: "Connecting",
      connected: "Connected",
      validating: "Validating",
      validated: "Validated",
      calculating: "Calculating",
      completed: "Calculation Completed",
    },
    close: "Close",
    regenerate: "Regenerate",
    addFactor: "Add Factor",
  },
  location: {
    noMatch: "No matching results",
    enterKeyword: "Please enter a keyword",
  },
  plan: {
    trialExceeded: "Trial calculations exceeded ({count})",
    trialExpired: "Trial period expired",
    monthlyExceeded: "Monthly calculations exceeded ({count})",
    subscriptionExpired: "Subscription period expired",
  },
};
